import { httpTokenCommon } from "../helper/http-common";
import { loginType } from "../types/login";

class LoginService {
  login(InputData: loginType) {
    return httpTokenCommon.post("auth/login", InputData);
  }
  logout() {
    return httpTokenCommon.post("auth/logout", undefined, { silent: true });
  }
  // Admin resets a customer's password.
  // Backend: POST /api/auth/reset  { userName, password }
  // Tries each login identity until one matches (customer code vs email on older accounts).
  async resetUserPassword(loginUsernames: string | string[], newPassword: string) {
    const candidates = Array.from(new Set(
      (Array.isArray(loginUsernames) ? loginUsernames : [loginUsernames])
        .map((n) => n.trim())
        .filter(Boolean)
    ));

    if (candidates.length === 0) {
      throw new Error("Login username is required");
    }

    let lastError: unknown;
    for (const userName of candidates) {
      try {
        return await httpTokenCommon.post(
          "auth/reset",
          { userName, password: newPassword },
          { silent: true }
        );
      } catch (error) {
        lastError = error;
        const status = (error as { response?: { status?: number; data?: unknown } }).response?.status;
        const body = (error as { response?: { data?: unknown } }).response?.data;
        const message = typeof body === "string" ? body : "";
        const notFound =
          status === 400 &&
          /username does not exist|user name does not exist/i.test(message);
        if (!notFound) throw error;
      }
    }
    throw lastError;
  }
  // User changes their own password after admin reset (force-change flow).
  // Backend: POST /api/auth/change-password  { currentPassword, newPassword }
  changeOwnPassword(currentPassword: string, newPassword: string) {
    return httpTokenCommon.post("auth/change-password", {
      currentPassword,
      newPassword,
    });
  }
}

const loginService = new LoginService();
export default loginService;
